import './FellowshipUnseenPoopReveal.css';

import { useState, useEffect, useCallback, useRef } from 'react';
import poopImg from '../assets/images/poop.png';
import poopSplat from '../assets/images/poopsplat.png';
import { URL } from './constants';

/** Spin phase length (ms) before switching to splat — same as egg. */
const POOP_SPIN_MS = 2_500;

/** Splat fade length (ms) — same as egg. */
const POOP_SPLAT_ANIM_MS = 4_500;

/**
 * One pooper: spin poop, then splat fades, then onComplete(pooper).
 * @param {{ pooper: string, onComplete: (pooper: string) => void }} props
 */
function PoopReveal({ pooper, onComplete }) {
  const [stage, setStage] = useState('spin');
  const finishedRef = useRef(false);

  useEffect(() => {
    finishedRef.current = false;
    setStage('spin');
    const id = window.setTimeout(() => setStage('splat'), POOP_SPIN_MS);
    return () => window.clearTimeout(id);
  }, [pooper]);

  useEffect(() => {
    if (stage !== 'splat') return;
    const id = window.setTimeout(() => {
      if (finishedRef.current) return;
      finishedRef.current = true;
      onComplete(pooper);
    }, POOP_SPLAT_ANIM_MS + 400);
    return () => window.clearTimeout(id);
  }, [stage, pooper, onComplete]);

  const title = `${pooper} has reached Mordor and pooped on you`;

  const onSplatAnimationEnd = (e) => {
    if (e.target !== e.currentTarget) return;
    if (finishedRef.current) return;
    finishedRef.current = true;
    onComplete(pooper);
  };

  return (
    <div
      className="fellowship-unseen-poop-overlay"
      role="alertdialog"
      aria-modal="true"
      aria-live="assertive"
      aria-label={title}
    >
      <div className="fellowship-unseen-poop-card">
        <p className="fellowship-unseen-poop-title">{title}</p>
        <div className="fellowship-unseen-poop-img-wrap">
          <div
            className={`fellowship-unseen-poop-phase ${
              stage === 'spin'
                ? 'fellowship-unseen-poop-phase--spin-visible'
                : 'fellowship-unseen-poop-phase--off'
            }`}
            aria-hidden={stage !== 'spin'}
          >
            <div className="fellowship-unseen-poop-spin-wrap">
              <img
                src={poopImg}
                alt=""
                className="fellowship-unseen-poop-large"
                decoding="async"
              />
            </div>
          </div>
          <div
            className={`fellowship-unseen-poop-phase ${
              stage === 'splat'
                ? 'fellowship-unseen-poop-phase--splat-visible fellowship-unseen-poop-splat-wrap'
                : 'fellowship-unseen-poop-phase--preload'
            }`}
            style={
              stage === 'splat'
                ? {
                    WebkitAnimationDuration: `${POOP_SPLAT_ANIM_MS}ms`,
                    animationDuration: `${POOP_SPLAT_ANIM_MS}ms`,
                  }
                : undefined
            }
            onAnimationEnd={stage === 'splat' ? onSplatAnimationEnd : undefined}
            aria-hidden={stage !== 'splat'}
          >
            <img
              src={poopSplat}
              alt=""
              className="fellowship-unseen-poop-splat-img"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * @param {{ poopers: { pooper: string }[], active?: boolean }} props
 */
export default function FellowshipUnseenPoopReveal({ poopers, active = true }) {
  const [index, setIndex] = useState(0);

  const handleComplete = useCallback(async (pooperName) => {
    if (!pooperName) {
      setIndex((i) => i + 1);
      return;
    }
    try {
      const res = await fetch(`${URL}/seen_poop`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ pooper: pooperName }),
      });
      if (!res.ok) {
        console.error('seen_poop failed', res.status);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIndex((i) => i + 1);
    }
  }, []);

  if (!active || !poopers.length || index >= poopers.length) return null;

  return (
    <PoopReveal
      key={index}
      pooper={poopers[index].pooper}
      onComplete={handleComplete}
    />
  );
}
